
(()=>{
  const BASE='/apps/atelier-photos/a6';
  const ENDPOINT='https://08a09c5750337d9dbff1991cce9990cd.eu.r2.cloudflarestorage.com';
  let warmed=false;
  const wait=ms=>new Promise(resolve=>setTimeout(resolve,ms));
  function batchId(){return Array.from(crypto.getRandomValues(new Uint8Array(16)),byte=>byte.toString(16).padStart(2,'0')).join('');}
  function warm(){
    if(warmed)return;warmed=true;

    fetch('https://latelier-shopify-print-generator.onrender.com/health',
      {mode:'no-cors',credentials:'omit',cache:'no-store'}).catch(()=>{});
  }
  async function describe(file){
    const digest=await crypto.subtle.digest('SHA-256',await file.arrayBuffer());
    return {bytes:file.size,type:file.type,sha256:Array.from(new Uint8Array(digest),byte=>byte.toString(16).padStart(2,'0')).join('')};
  }
  async function post(action,data){
    for(let attempt=0;attempt<3;attempt++){
      try{
        const response=await fetch(`${BASE}/${action}`,{method:'POST',credentials:'same-origin',cache:'no-store',
          headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(data),signal:AbortSignal.timeout(70000)});
        if(response.ok)return await response.json();
        if(response.status<500||attempt===2)throw new Error('Private upload request rejected');
      }catch(error){if(attempt===2)throw error;}
      await wait(3000);
    }
    throw new Error('Private upload unavailable');
  }
  async function upload(prepared,batch){
    if(!/^[a-f0-9]{32}$/.test(batch)||![1,2,4,8].includes(prepared.length))throw new Error('Invalid photo batch');
    const manifest={v:'a6-portrait-v1',pack:prepared.length,photos:[]};
    const files=new Map();
    for(const [index,item] of prepared.entries()){
      manifest.photos.push({photo:await describe(item.file),preview:await describe(item.preview),crop:item.crop});
      files.set(`photo-${String(index+1).padStart(2,'0')}`,item.file);
      files.set(`preview-${String(index+1).padStart(2,'0')}`,item.preview);
    }
    const {session}=await post('start',{batch,manifest});
    if(typeof session!=='string')throw new Error('Missing private upload session');
    const {targets}=await post('targets',{session});
    if(!Array.isArray(targets)||(targets.length!==0&&targets.length!==files.size))throw new Error('Invalid private upload targets');
    const seen=new Set();

    for(const target of targets){
      const file=files.get(target.label),url=new URL(target.url);
      if(!file||seen.has(target.label)||url.origin!==ENDPOINT||url.username||url.password||
        url.pathname!==`/latelier-customer-photos/latelier-photos-v1/objects/${batch}/${target.label}`||
        target.headers?.['Content-Type']!==file.type||target.headers?.['If-None-Match']!=='*')throw new Error('Unsafe private upload target');
      seen.add(target.label);
      const response=await fetch(url,{method:'PUT',credentials:'omit',referrerPolicy:'no-referrer',
        headers:target.headers,body:file,signal:AbortSignal.timeout(90000)});

      if(!response.ok&&response.status!==412)throw new Error('Private photo upload failed');
    }
    const {properties}=await post('seal',{session});
    if(!properties||properties._A6Storage!=='r2-v1'||properties._A6UploadId!==batch||
      properties._A6Pack!==String(prepared.length)||typeof properties._A6Receipt!=='string'||properties['_Production Product']!=='a6-portrait-v1')throw new Error('Private photo confirmation is missing');
    const allowed=/^_A6(?:Storage|Receipt|Pack|UploadId|Preview[1-8])$|^_Production Product$/;
    if(Object.keys(properties).some(key=>!allowed.test(key)))throw new Error('Unexpected private photo property');
    return properties;
  }
  window.AtelierA6Photos=Object.freeze({batchId,warm,upload});
})();
